/**
 * 权限指令 v-permission
 * @author LWX
 * @date 2026-03-23
 * 使用: v-permission="['user:add']"
 */

import Vue from 'vue'
import store from '@/store'

Vue.directive('permission', {
    inserted(el, binding) {
        const { value } = binding
        const permissions = store.getters.permissions || []
        const isSuperAdmin = store.getters.isSuperAdmin || false

        // 如果没有传入权限，不处理
        if (!value || !value.length) {
            return
        }

        // 超级管理员拥有所有权限，直接放行
        if (isSuperAdmin) {
            return
        }

        // 检查是否有通配符权限
        if (permissions.includes('*:*:*')) {
            return
        }

        // 检查具体权限
        const hasPermission = permissions.some(p => value.includes(p))
        if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
})